var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMainImgFahion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 272,
    height: 418,
    viewBox: "0 0 272 418",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-main_img_fahion"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 272,
    height: 418
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "main_img_fahion",
    clipPath: "url(#clip-main_img_fahion)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_300",
    "data-name": "\\uADF8\\uB8F9 300"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_102",
    "data-name": "\\uC0AC\\uAC01\\uD615 102",
    width: 272,
    height: 418,
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_292",
    "data-name": "\\uADF8\\uB8F9 292"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_288",
    "data-name": "\\uADF8\\uB8F9 288",
    transform: "translate(4404.147 -1653.5)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "\\uD0C0\\uC6D0_47",
    "data-name": "\\uD0C0\\uC6D0 47",
    cx: 100.281,
    cy: 19.211,
    rx: 100.281,
    ry: 19.211,
    transform: "translate(-4332.71 2033.078)",
    fill: "#db3633"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_258",
    "data-name": "\\uADF8\\uB8F9 258"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_214",
    "data-name": "\\uADF8\\uB8F9 214",
    transform: "translate(-4323.355 1679.777)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_213",
    "data-name": "\\uADF8\\uB8F9 213",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_157",
    "data-name": "\\uD328\\uC2A4 157",
    d: "M453.419,413.783V390.392H348.827v23.391a53.22,53.22,0,0,0-39.065,51.273V678.287a29.663,29.663,0,0,0,29.663,29.663h123.4a29.663,29.663,0,0,0,29.663-29.663V465.056A53.219,53.219,0,0,0,453.419,413.783Z",
    transform: "translate(-309.762 -334.946)",
    fill: "#fff",
    stroke: "#161619",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_85",
    "data-name": "\\uC0AC\\uAC01\\uD615 85",
    width: 182.722,
    height: 199.191,
    transform: "translate(0 137.895)",
    fill: "#fff",
    stroke: "#161619",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_86",
    "data-name": "\\uC0AC\\uAC01\\uD615 86",
    width: 146.178,
    height: 65.528,
    rx: 18.966,
    transform: "translate(18.272)",
    fill: "#fff",
    stroke: "#161619",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("text", {
    id: "FASION_DESIGN",
    "data-name": "FASION DESIGN",
    transform: "translate(26.426 255.463)",
    fill: "#161619",
    fontSize: 24,
    fontFamily: "Orbitron-Bold, Orbitron",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "FASION"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 29
  }, "DESIGN"))), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_158",
    "data-name": "\\uD328\\uC2A4 158",
    d: "M1675.522,996.372A23.519,23.519,0,0,0,1652,1019.891a23.518,23.518,0,0,0-23.518-23.518A23.519,23.519,0,0,0,1652,972.854,23.519,23.519,0,0,0,1675.522,996.372Z",
    transform: "translate(-5832.479 867.928)",
    fill: "#db3633"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_99",
    "data-name": "\\uC0AC\\uAC01\\uD615 99",
    width: 272,
    height: 418,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("text", {
    id: "Lookbook_Film_Textile",
    "data-name": "Lookbook / Film / Textile",
    transform: "translate(105.761 353)",
    fill: "#c32927",
    fontSize: 12,
    fontFamily: "NotoSans-Regular, Noto Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Lookbook / Film / Textile")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainImgFahion);
export default __webpack_public_path__ + "static/media/main_img_fahion.c0d08608fefa9596e443ca904c13ecc0.svg";
export { ForwardRef as ReactComponent };